import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useModals } from 'almanac-ui/Modal'
import { useShowIntegrationSuccessModal } from 'screens/OAuthRedirectV2/hooks'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentPlan } from 'hooks/useCurrentPlan'
import { PurchaseAdditionalAccountModal } from 'components/PurchaseAdditionalAccountModal/PurchaseAdditionalAccountModal'

interface UseAddAdditionalAccountOptions {
  provider: ExternalIntegrationEnum
  onConnectSuccess?: (integrations: ExternalIntegration[]) => void
}

export const useAddAdditionalAccount = ({ provider, onConnectSuccess }: UseAddAdditionalAccountOptions) => {
  const { connect } = useConnectAccountPopup()
  const { openModal } = useModals()
  const showIntegrationSuccessModal = useShowIntegrationSuccessModal()
  const { data: currentSubscription } = useCurrentPlan()
  const isTrialing = currentSubscription?.status === 'trialing'

  const showSuccessModal = (integration: ExternalIntegration) => {
    showIntegrationSuccessModal({
      provider: integration.provider,
      result: {
        type: SUCCESS_RESPONSE_TYPE,
        data: { external_integration: integration },
      } as any,
      onClose: () => {},
    })
  }

  const handleAddAccount = (popup?: Window) => {
    connect(popup, {
      isAdditionalAccount: true,
      onConnect: (newIntegrations: ExternalIntegration[]) => {
        if (newIntegrations.length > 0) {
          const newIntegration = newIntegrations[0]

          // If trialing, skip purchase modal and show success modal directly
          if (isTrialing) {
            showSuccessModal(newIntegration)
          } else {
            // Otherwise, show purchase modal
            openModal(PurchaseAdditionalAccountModal, {
              integration: newIntegration,
              onClose: () => {},
              onPurchase: () => showSuccessModal(newIntegration),
            })
          }
        }

        // Call the optional success callback
        onConnectSuccess?.(newIntegrations)
      },
    })
  }

  return handleAddAccount
}
